import React, { useState, useEffect, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import logo from '../images/TD AI Logo 2 Color Clear.png';
import mslogo from '../images/mslogo.png';

import {
  LoginViaUserIdPwd,
  LoginViaMicrosoft,
  LoginViaMSOAuth2,
} from '../actions/LoginActions';

const LoginView = () => {

  const dispatch = useDispatch();
  const loginInfo = useSelector(state => state.loginInfo.value);
  const appInfo = useSelector(state => state.appInfo.value);
  const [userId, updateUserId] = useState('');
  const userNameRef = useRef(null);
  const [password, updatePassword] = useState('');
  const [hasError, updateHasError] = useState(false);
  const [loggingIn, updateLoggingIn] = useState(false);
  const [errorMessage, updateErrorMessage] = useState('Unable to reach server');

  useEffect(() => {
    if (window.location.search.startsWith('?auth=')) {
      // SignInMicrosoft redirects back here with ?auth=<access token>, or ?auth=error:<code> when
      // the OAuth exchange failed. An error string is not a token, so show it instead of sending
      // it to the API - doing that produces a login response with no permissions and crashes.
      let auth = new URLSearchParams(window.location.search).get('auth');
      if (auth !== null && auth.startsWith('error:')) {
        console.log('Microsoft sign-in failed:', auth);
        updateHasError(true);
        updateErrorMessage(
          `Microsoft sign-in failed (${auth.replace('error:', '').trim()}). Please contact your administrator.`
        );
      } else {
        console.log('LoginViaMSOauth2');
        LoginViaMSOAuth2(auth, dispatch);
        //this._sendAuthRequest(auth);
      }
    }

    let isLoggedIn = loginInfo.loggedIn;
    if (loginInfo.loggedIn === true) {
      // route to app page
      updateHasError(false);

      updateErrorMessage('');
    }
    if(loginInfo.loggedIn === false && loginInfo.errorMessage.length > 0)
    {
      updateHasError(true);
      updateLoggingIn(false);
      updateErrorMessage(loginInfo.errorMessage);
    }
    if(userId === '')
    {
      userNameRef.current.focus();
    }
  }, [loginInfo]);

  const onUserIdChange = (e) => {
    let uid = e.target.value;
    updateUserId(uid);
  }

  const onPasswordChange = (e) => {
    let pwd = e.target.value;
    updatePassword(pwd);
  }

  const onPwdKeyDown = (e) => {
    if (e.code === 'Enter') {
      onLoginClick();
    }
  }


  const onLoginClick = () => {
    if(checkUserIdPassword())
    {
      console.log('checkPassword');
      console.log(dispatch);
      LoginViaUserIdPwd(userId, password, dispatch);
      updateLoggingIn(true);
    }
  }

  const checkUserIdPassword = () => {
    if(userId === '') {
      updateErrorMessage('Username is required');
      updateHasError(true);
      return false;
    }
    if(password === '') {
      updateErrorMessage('Password is required');
      updateHasError(true);
      return false;
    }
    //updateHasError(false);
    return true;
  }

  const signInWithMicrosoft = () => {
    LoginViaMicrosoft();
  }

    return (
      <div className='App'>
        <header className='App-header'>
          <img src={logo} className='App-logo' alt='logo' />
          <div className='App-version'>
            {`Version ${import.meta.env.VITE_VERSION}`}
          </div>
          <div className='card login-form'>
            <div className='card-body' style={{ backgroundColor: '#D8FDFF' }}>
              <input
                type='text'
                value={userId}
                ref={userNameRef}
                autoComplete='off'
                onChange={onUserIdChange}
                className='form-control login-input'
                placeholder='Username'
                id='txtUsername'
              />
              <input
                type='password'
                role='password'
                value={password}
                onChange={onPasswordChange}
                className='form-control login-input'
                placeholder='Password'
                onKeyDown={onPwdKeyDown}
                id='txtPassword'
              />
              {loggingIn &&
                <button className='btn btn-secondary' style={{width: '100%'}} disabled >
                  <i className='fa-regular fa-spinner-scale fa-spin' />
                </button>
                }
              {!loggingIn &&
                <button onClick={onLoginClick} className='login-button btn'>
                  <i className='fa-solid fa-sign-in-alt' /> Login
                </button>
              }
              {appInfo.showMSOAuthButton && (
                <div className='msbutton' onClick={signInWithMicrosoft}>
                  <img
                    style={{
                      paddingTop: '9px',
                      float: 'left',
                      paddingRight: '12px',
                    }}
                    alt='mslogo'
                    src={mslogo}
                  />
                  <div
                    style={{
                      lineHeight: '42px',
                      float: 'left',
                    }}
                  >
                    Sign in with Microsoft
                  </div>
                </div>
              )}
            </div>
          </div>
          {hasError && (
            <div className='alert alert-danger' role='loginError' style={{ marginTop: '10px' }}>
              <i className='fa-solid fa-times-circle' />{' '}
              {errorMessage}
            </div>
          )}
        </header>
      </div>
    );
}

export default LoginView;
